import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, Section } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";
import api, { errMsg, TIMEZONES } from "@/lib/api";

export default function Account() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ phone: user.phone || "", timezone: user.timezone || "Asia/Kolkata" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  const save = async () => {
    try { const { data } = await api.put("/auth/me", form); setUser(data); toast.success("Profile saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const changePw = async () => {
    try {
      await api.post("/auth/change-password", pw);
      setPw({ current_password: "", new_password: "" });
      toast.success("Password updated - use it for both K-FitHUB and the CRM");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader eyebrow="Profile" title="Account" testid="account-title" />
      <div className="grid lg:grid-cols-2 gap-6">
        <Section title="Profile">
          <div className="space-y-4">
            <div><Label>Name</Label><div className="mt-1 text-sm" data-testid="account-name">{user.name}</div><p className="text-xs text-slate-500">Managed in the CRM.</p></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1" data-testid="account-phone-input" /></div>
            <div>
              <Label>Timezone (reminders use this)</Label>
              <Select value={form.timezone} onValueChange={(v) => setForm({ ...form, timezone: v })}>
                <SelectTrigger className="mt-1" data-testid="account-timezone-select"><SelectValue /></SelectTrigger>
                <SelectContent className="max-h-72">{TIMEZONES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <Button onClick={save} data-testid="account-save-btn">Save profile</Button>
          </div>
        </Section>
        <Section title="Password">
          <div className="space-y-4">
            <p className="text-xs text-slate-500">One Supabase login is shared by K-FitHUB and the CRM.</p>
            <div><Label>Current password</Label><Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="mt-1" data-testid="current-password-input" /></div>
            <div><Label>New password (min 8)</Label><Input type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="mt-1" data-testid="new-password-input" /></div>
            <Button onClick={changePw} disabled={pw.new_password.length < 8} data-testid="change-password-btn">Update password</Button>
          </div>
        </Section>
      </div>
    </div>
  );
}
